module.exports = __webpack_public_path__ + "img/8.1498e0b6.png";